export default __webpack_public_path__ + "af136019b28e5408ff01e3efc543bd27.jpg";